/* eslint-disable import/prefer-default-export */
import { mutate } from 'swr'

import * as T from 'types'

import { api } from './api'
import { titleCheckKey } from './swr/useTitleCheck'

export const runTitleCheck = async (
  listingId: string,
): Promise<[T.ITitleCheckResponse | undefined, Error | undefined]> => {
  try {
    const response = await api.api.post<T.ITitleCheckResponse>(
      `/title-checks/listing/${listingId}`,
      {},
    )

    if (!response.ok || !response.data) {
      const errorMessage = (response.data as any)?.message || 'Title check failed'
      throw new Error(errorMessage)
    }

    mutate(titleCheckKey(listingId), response.data, false)
    return [response.data, undefined]
  } catch (error) {
    const err = error instanceof Error ? error : new Error('Title check failed')
    return [undefined, err]
  }
}
